import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,  
} from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import apiClient from "./api/apiClient";

const BankVerificationCaseDetails = () => {
  const { caseId } = useParams();
  const navigate = useNavigate();

  const [caseDetails, setCaseDetails] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [uploads, setUploads] = useState([]);
  const [mode, setMode] = useState(caseDetails?.mode || "");
  const [colorCode, setColorCode] = useState(caseDetails?.colorCode || "");
  const [status, setStatus] = useState("");
  const [remarks, setRemarks] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewType, setPreviewType] = useState("");
  const [previewFile, setPreviewFile] = useState("");
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get(`/bankverifications/${caseId}`);
        setCaseDetails(res.data);

        setStatus(res.data.status || "");
        setRemarks(res.data.remarks || "");
        setMode(res.data.mode || "");
        setColorCode(res.data.colorCode || "");

        const [photosRes, videosRes, uploadsRes] = await Promise.all([
          apiClient.get(`/meetingsmediacontroller/${res.data.caseId}/photos`),
          apiClient.get(`/meetingsmediacontroller/${res.data.caseId}/videos`),
          apiClient.get(`/meetingsmediacontroller/${res.data.caseId}/uploads`),
        ]);
        setPhotos(photosRes.data || []);
        setVideos(videosRes.data || []);
        setUploads(uploadsRes.data || []);

        const historyRes = await apiClient.get(`/bankverifications/${res.data.caseId}/history`);
        setHistory(historyRes.data || []);
        
      } catch (err) {
        console.error("Error fetching case details:", err);
      }
    };

    fetchData();
  }, [caseId]);

  const handleSave = async () => {
    try {
/*      await apiClient.put(`/bankverifications/${caseId}`, {
        caseId :caseDetails.caseId,
        checkId:caseDetails.checkId,
        status,
        remarks,
        allocatedToAssociate:caseDetails.allocatedToAssociate
      });*/
      await apiClient.put(`/bankverifications/updatestatus/${caseId}`,{status,
        remarks,mode,colorCode});
      navigate("/bankverificationallocatedtoassociate");
    } catch (err) {
      console.error("Error saving case details:", err);
    }
  };

  const handleCancel = () => {
    navigate("/bankverificationallocatedtoassociate");
  };

  // 🔹 Helper to extract filename from server URL
/*  const getFilename = (url) => {
    const parts = url.split("/");
    return decodeURIComponent(parts[parts.length - 2]); // filename is second last part
  };*/

  if (!caseDetails) {
    return <Typography variant="h6">Loading case details...</Typography>;
  }
  const getFilename = (filePath) => {
    // If backend returns full path like "C:/uploads/case1/photos/photo1.jpg"
    return filePath.split(/[\\/]/).pop();  // works for Windows \ and Linux /
  };
  
  const getDownloadUrl = (caseId, type, filePath) => {
    const filename = getFilename(filePath);
    return `/meetingsmediacontroller/${caseId}/${type}/${filename}/download`;
  };
  
  const handleDownload = async (type, filename) => {
    try {
      console.log("file name is ",filename);
//      const rawFilename = filename.split("/").pop();
      const rawFilename = filename;
      const url = `/meetingsmediacontroller/downloadfiles/${caseDetails.caseId}/${type}/${rawFilename}/download`;
  
      const response = await apiClient.get(url, { responseType: "blob" });
  
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = rawFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Failed to download file: " + filename);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
      ];
  
      if (!allowedTypes.includes(file.type)) {
        alert("Only PDF, JPG, and PNG files are allowed.");
        e.target.value = ""; // reset file input
        return;
      }
  
      setSelectedFile(file);
    }
  };
  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file first");
      return;
    }
  
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
  
      await apiClient.post(
        `/meetingsmediacontroller/${caseDetails.caseId}/uploads`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
  
      alert("File uploaded successfully!");
  
      // Refresh uploads after successful upload
      const uploadsRes = await apiClient.get(
        `/meetingsmediacontroller/${caseDetails.caseId}/uploads`
      );
      setUploads(uploadsRes.data || []);
  
      setSelectedFile(null);
    } catch (err) {
      console.error("File upload failed:", err);
      alert("Failed to upload file");
    }
  };    
  const handlePreviewOpen = (type, filename) => {
    setPreviewType(type);
    setPreviewFile(filename);
    setPreviewOpen(true);
  };
  
  const handlePreviewClose = () => {
    setPreviewOpen(false);
    setPreviewType("");
    setPreviewFile("");
  };
  
  const handleDeleteFile = async () => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;
  
    try {
      await apiClient.delete(
        `/meetingsmediacontroller/${caseDetails.caseId}/${previewType}/${previewFile}`
      );
      alert("File deleted successfully.");
  
      // refresh list
      if (previewType === "photos") {
        const res = await apiClient.get(`/meetingsmediacontroller/${caseDetails.caseId}/photos`);
        setPhotos(res.data || []);
      } else if (previewType === "uploads") {
        const res = await apiClient.get(`/meetingsmediacontroller/${caseDetails.caseId}/uploads`);
        setUploads(res.data || []);
      }
  
      handlePreviewClose();
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete file.");
    }
  };
  const handleRenameClick = () => {
    setNewFileName(previewFile);
    setRenameDialogOpen(true);
  };
  
  const handleRenameConfirm = async () => {
    if (!newFileName || newFileName.trim() === "") {
      alert("File name cannot be empty.");
      return;
    }
  
    try {
      await apiClient.put(
        `/meetingsmediacontroller/${caseDetails.caseId}/${previewType}/${previewFile}/rename`,
        { newFileName }
      );
      alert("File renamed successfully.");
  
      // Refresh list
      if (previewType === "photos") {
        const res = await apiClient.get(`/meetingsmediacontroller/${caseDetails.caseId}/photos`);
        setPhotos(res.data || []);
      } else if (previewType === "uploads") {
        const res = await apiClient.get(`/meetingsmediacontroller/${caseDetails.caseId}/uploads`);
        setUploads(res.data || []);
      }
  
      setRenameDialogOpen(false);
      handlePreviewClose();
    } catch (err) {
      console.error("Rename failed:", err);
      alert("Failed to rename file.");
    }
  };
  const handleDownloadPdf = async (id) => {
    try {
      // Make a GET request to download the PDF as a blob
      const response = await apiClient.get(`/bankverifications/${id}/pdf`, {
        responseType: 'blob', // Important — tells Axios it's binary data
      });
  
      // Create a blob URL for download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bank_verification_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // cleanup
  
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download PDF. Please try again.');
    }
  };
        
  return (
    <Box sx={{ p: 3 }}>
      {/* Case Info */}
      <Card sx={{ mb: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Case Details
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Case ID:</Typography>
              <Typography variant="body1">{caseDetails.caseId}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Type:</Typography>
              <Typography variant="body1">{caseDetails.employmentType}</Typography>
            </Grid>            
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Client Name:</Typography>
              <Typography variant="body1">{caseDetails.clientName}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Candidate Name:</Typography>
              <Typography variant="body1">{caseDetails.candidateName}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Company Name:</Typography>
              <Typography variant="body1">{caseDetails.companyName}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Mobile Number:</Typography>
              <Typography variant="body1">{caseDetails.mobilePhoneNumber}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Email:</Typography>
              <Typography variant="body1">{caseDetails.email}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Tenure From:</Typography>
              <Typography variant="body1">
                {caseDetails.tenureFrom
                  ? new Date(caseDetails.tenureFrom).toLocaleDateString()
                  : "-"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1">Tenure To:</Typography>
              <Typography variant="body1">
                {caseDetails.tenureTo
                  ? new Date(caseDetails.tenureTo).toLocaleDateString()
                  : "-"}
              </Typography>
            </Grid>

            {/* Editable Status */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={status}
                  label="Status"
                  onChange={(e) => {
                    const newStatus = e.target.value;
                    setStatus(newStatus);
                
                    if (newStatus === "RESCHEDULED") {
                      navigate("/createmeetingrequest", {
                        state: {
                          title: "Bank Statement Verification",
                          inviteeName: caseDetails.candidateName,
                          inviteeEmail: caseDetails.email,
                          inviteeMobilePhoneNumber: caseDetails.mobilePhoneNumber,
                          bankVerificationId: caseDetails.id
                        },
                      });
                    }
                  }}

                >
                  <MenuItem value="SCHEDULED">SCHEDULED</MenuItem>
                  <MenuItem value="COMPLETED">COMPLETED</MenuItem>
                  <MenuItem value="INITIATED-TO-PV">INITIATED TO PV</MenuItem>
                  <MenuItem value="FOLLOWUP-MAIL-1-SENT">FOLLOWUP MAIL 1 SENT</MenuItem>
                  <MenuItem value="FOLLOWUP-MAIL-2-SENT">FOLLOWUP MAIL 2 SENT</MenuItem>
                  <MenuItem value="FOLLOWUP-MAIL-3-SENT">FOLLOWUP MAIL 3 SENT</MenuItem>
                  <MenuItem value="STOP-CHECK">STOP CHECK</MenuItem>
                  <MenuItem value="UNABLE-TO-VERIFY">UNABLE TO VERIFY</MenuItem>
                  <MenuItem value="RESCHEDULED">RE-SCHEDULED</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* Mode Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>Mode</InputLabel>
                <Select
                  value={mode}
                  label="Mode"
                  onChange={(e) => setMode(e.target.value)}
                >
                  <MenuItem value="PHYSICAL">PHYSICAL</MenuItem>
                  <MenuItem value="ONLINE">ONLINE</MenuItem>
                  <MenuItem value="NA">NA</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* ColorCode Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>Color Code</InputLabel>
                <Select
                  value={colorCode}
                  label="Color Code"
                  onChange={(e) => setColorCode(e.target.value)}
                >
                  <MenuItem value="GREEN">GREEN</MenuItem>
                  <MenuItem value="RED">RED</MenuItem>
                  <MenuItem value="AMBER">AMBER</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* Editable Remarks */}
            <Grid item xs={12} md={12}>
              <TextField
                label="Remarks"
                fullWidth
                multiline
                rows={3}
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save
            </Button>
            <Button variant="contained" color="success" onClick={() => handleDownloadPdf(caseDetails.id)}>
              Download PDF
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleCancel}>
              Cancel
            </Button>
          </Stack>
        </CardContent>
      </Card>

      {/* Photos Section */}
      <Card sx={{ mb: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Photos
          </Typography>
          <Divider sx={{ mb: 2 }} />
          {photos.length > 0 ? (
            <Grid container spacing={2}>
                {photos.map((filename, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 1, textAlign: "center" }}>
                      <Typography variant="body2" sx={{ mb: 1 }}>{filename}</Typography>
{/*                      <Button
                        onClick={() => handleDownload("photos", filename)}
                        startIcon={<FileDownload />}
                        fullWidth
                      >
                        Download
                </Button> */}
                <Button
                  onClick={() => handlePreviewOpen("photos", filename)}
                  startIcon={<FileDownload />}
                  fullWidth
                >
                  View / Download
                </Button>

                    </Box>
                  </Grid>
                ))}

            </Grid>
          ) : (
            <Typography variant="body2">No photos uploaded.</Typography>
          )}
        </CardContent>
      </Card>

      {/* Videos Section */}
      <Card sx={{ mb: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Call Recording
          </Typography>
          <Divider sx={{ mb: 2 }} />
          {videos.length > 0 ? (
            <Grid container spacing={2}>
              {videos.map((filename, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 1, textAlign: "center" }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>{filename}</Typography>
                    <Button
                      onClick={() => handleDownload("videos", filename)}
                      startIcon={<FileDownload />}
                      fullWidth
                    >
                      Download
                    </Button>
                  </Box>
                </Grid>
              ))}

            </Grid>
          ) : (
            <Typography variant="body2">No videos uploaded.</Typography>
          )}
        </CardContent>
      </Card>

      {/* Uploads Section */}
      <Card sx={{ mb: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Other Uploads
          </Typography>
          <Divider sx={{ mb: 2 }} />
          {uploads.length > 0 ? (
            <Grid container spacing={2}>
              {uploads.map((filename, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 1, textAlign: "center" }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>{filename}</Typography>
{/*                    <Button
                      onClick={() => handleDownload("uploads", filename)}
                      startIcon={<FileDownload />}
                      fullWidth
                    >
                      Download
              </Button> */}
              <Button
                onClick={() => handlePreviewOpen("uploads", filename)}
                startIcon={<FileDownload />}
                fullWidth
              >
                View / Download
              </Button>

                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body2">No files uploaded.</Typography>
          )}
        </CardContent>
      </Card>
{/* File Upload Section */}
<Card sx={{ mb: 3, boxShadow: 3 }}>
  <CardContent>
    <Typography variant="h6" gutterBottom>
      Upload a File
    </Typography>
    <Divider sx={{ mb: 2 }} />

    <Stack direction="row" spacing={2} alignItems="center">
      <Button variant="outlined" component="label">
        Choose File
        <input
          type="file"
          hidden
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={handleFileChange}
       />
      </Button>

      {selectedFile && (
        <Typography variant="body2">{selectedFile.name}</Typography>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={handleFileUpload}
        disabled={!selectedFile}
      >
        Upload
      </Button>
    </Stack>
  </CardContent>
</Card>
{/* Bank Verification History Section */}
<Card sx={{ mb: 3, boxShadow: 3 }}>
  <CardContent>
    <Typography variant="h6" gutterBottom>
      Bank Verification History
    </Typography>
    <Divider sx={{ mb: 2 }} />

    {history.length > 0 ? (
      <Box sx={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Iteration</th>
              <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Status</th>
              <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Remarks</th>
              <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Modified Date</th>
            </tr>
          </thead>
          <tbody>
            {history.map((entry, index) => (
              <tr key={entry.id || index}>
                <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>
                  {entry.iterationNumber}
                </td>
                <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>
                  {entry.status}
                </td>
                <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>
                  {entry.remarks}
                </td>
                <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>
                  {entry.modifiedAt
                    ? new Date(entry.modifiedAt).toLocaleString()
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    ) : (
      <Typography variant="body2">No history records available.</Typography>
    )}
  </CardContent>
</Card>

<Dialog open={previewOpen} onClose={handlePreviewClose} maxWidth="md" fullWidth>
  <DialogTitle>Preview File</DialogTitle>
{/*  <DialogContent dividers sx={{ textAlign: "center" }}>
    {previewFile ? (
      previewFile.toLowerCase().endsWith(".pdf") ? (
        <iframe
          src={`/meetingsmediacontroller/${caseDetails.caseId}/${previewType}/${previewFile}/download`}
          title="PDF Preview"
          width="100%"
          height="500px"
          style={{ border: "none" }}
        />
      ) : (
        <img
          src={`/meetingsmediacontroller/${caseDetails.caseId}/${previewType}/${previewFile}/download`}
          alt={previewFile}
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      )
    ) : (
      <Typography>No file selected</Typography>
    )}
    </DialogContent> */}
  <DialogContent dividers sx={{ textAlign: "center" }}>
    {previewFile ? (
      <FilePreview
        caseId={caseDetails.caseId}
        previewType={previewType}
        previewFile={previewFile}
      />
    ) : (
      <Typography>No file selected</Typography>
    )}
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => handleDownload(previewType, previewFile)}
      color="primary"
      variant="contained"
    >
      Download
    </Button>
    <Button onClick={handleRenameClick} color="warning" variant="contained">
    Rename
  </Button>
    <Button onClick={handleDeleteFile} color="error" variant="contained">
      Delete
    </Button>
    <Button onClick={handlePreviewClose} color="secondary" variant="outlined">
      Close
    </Button>
  </DialogActions>
</Dialog>
<Dialog open={renameDialogOpen} onClose={() => setRenameDialogOpen(false)}>
  <DialogTitle>Rename File</DialogTitle>
  <DialogContent>
    <TextField
      label="New File Name"
      fullWidth
      value={newFileName}
      onChange={(e) => setNewFileName(e.target.value)}
      helperText="Include extension (e.g., photo1.jpg)"
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setRenameDialogOpen(false)} color="secondary">
      Cancel
    </Button>
    <Button onClick={handleRenameConfirm} color="primary" variant="contained">
      Rename
    </Button>
  </DialogActions>
</Dialog>


    </Box>
  );
};

const FilePreview = ({ caseId, previewType, previewFile }) => {
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    const fetchFile = async () => {
      try {
        const response = await apiClient.get(
          `/meetingsmediacontroller/downloadfiles/${caseId}/${previewType}/${previewFile}/download`,
          { responseType: "blob" }
        );
        const contentType =
          response.headers["content-type"] ||
          (previewFile.toLowerCase().endsWith(".pdf")
            ? "application/pdf"
            : "image/*");

        const blob = new Blob([response.data], { type: contentType });
        const blobUrl = URL.createObjectURL(blob);
        setFileUrl(blobUrl);

//        const blobUrl = URL.createObjectURL(response.data);
//        setFileUrl(blobUrl);
      } catch (error) {
        console.error("Error loading file:", error);
      }
    };

    fetchFile();

    return () => {
      if (fileUrl) URL.revokeObjectURL(fileUrl);
    };
  }, [caseId, previewType, previewFile]);

  if (!fileUrl) return <Typography>Loading preview...</Typography>;

  if (previewFile.toLowerCase().endsWith(".pdf")) {
    return (
      <iframe
        src={fileUrl}
        title="PDF Preview"
        width="100%"
        height="500px"
        style={{ border: "none" }}
      />
    );
  }

  return (
    <img
      src={fileUrl}
      alt={previewFile}
      style={{ maxWidth: "100%", maxHeight: "500px" }}
    />
  );
};


export default BankVerificationCaseDetails;
